import { Outlet } from "react-router-dom"

const Productlayout = () => {
    return(
        <div>
            <Outlet />
        </div>
    );
}

export default Productlayout;